/**
 * Navegación sin router.
 *
 * La app del personal es un asistente de nueve pantallas en línea, no un
 * sitio: se entra por la invitación o por el PIN y se avanza. Un router
 * completo aportaría rutas profundas que nadie va a escribir a mano y
 * añadiría una dependencia con un aviso de seguridad abierto en toda su rama
 * 6.x (redirección abierta en `<Link>`), sin fix salvo salto de mayor.
 *
 * Lo que sí hace falta y está aquí:
 *   · El botón "atrás" del sistema y el gesto de Android tienen que funcionar.
 *   · Volver atrás no puede sacar de la app a mitad de una limpieza.
 *
 * Se resuelve con el History API y una pila propia de estados.
 */

export type Pantalla =
    | { n: 'cargando' }
    | { n: 'alta'; token: string | null }
    | { n: 'crear_pin'; token: string }
    | { n: 'pin' }
    | { n: 'hoy' }
    | { n: 'qr' }
    | { n: 'recorrido'; limpieza: string }
    | { n: 'grabar'; limpieza: string; estancia: string }
    | { n: 'fotos'; limpieza: string; estancia: string }
    | { n: 'resumen'; limpieza: string }
    | { n: 'cola' }
    | { n: 'manual' };

export type Sentido = 'adelante' | 'atras';

/** El token de la invitación viaja tras el `#` para que no llegue al servidor. */
export function tokenDeInvitacion(): string | null {
    if (typeof location === 'undefined') {
        return null;
    }

    const hash = location.hash.replace(/^#/, '');
    if (/^[A-Za-z0-9_-]{20,}$/.test(hash)) {
        return hash;
    }

    return null;
}

/** El QR abre `/c/<qr_token>`. Se lee al arrancar y se limpia la URL. */
export function tokenQrDeUrl(): string | null {
    if (typeof location === 'undefined') {
        return null;
    }

    const m = /^\/c\/([a-z0-9]{32})$/.exec(location.pathname);

    return m?.[1] ?? null;
}

export function limpiarUrl(): void {
    if (typeof history !== 'undefined' && typeof location !== 'undefined') {
        history.replaceState(history.state, '', '/');
    }
}
